var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticStyle: { padding: "0 10px" },
      attrs: {
        "show-close": false,
        visible: _vm.requestToJoinDialogVisible,
        "before-close": _vm.handleClose,
        center: "",
        fullscreen: "",
        "custom-class": "contact-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.requestToJoinDialogVisible = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("div", { staticClass: "contact-title" }, [
                _vm._v("\n      Request to Join UNIFI Property\n      "),
                _c(
                  "div",
                  { staticClass: "icon", on: { click: _vm.handleClose } },
                  [_c("i", { staticClass: "el-icon-close" })]
                )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "requestToJoinForm",
              staticStyle: { "font-family": "DINosaur-a, sans-serif" },
              attrs: {
                model: _vm.requestToJoinForm,
                rules: _vm.rules,
                "label-position": "top",
                "label-width": "100px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "First Name",
                                    prop: "firstName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      placeholder: "Your first name"
                                    },
                                    model: {
                                      value: _vm.requestToJoinForm.firstName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestToJoinForm,
                                          "firstName",
                                          $$v
                                        )
                                      },
                                      expression: "requestToJoinForm.firstName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Last Name",
                                    prop: "lastName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "100",
                                      placeholder: "Your last name"
                                    },
                                    model: {
                                      value: _vm.requestToJoinForm.lastName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestToJoinForm,
                                          "lastName",
                                          $$v
                                        )
                                      },
                                      expression: "requestToJoinForm.lastName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Company",
                                    prop: "companyName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "100",
                                      placeholder: "Agency/Developer name"
                                    },
                                    model: {
                                      value: _vm.requestToJoinForm.companyName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestToJoinForm,
                                          "companyName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "requestToJoinForm.companyName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Location", prop: "state" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "popper-append-to-body": false,
                                        clearable: "",
                                        filterable: "",
                                        placeholder: "Select a state"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.validateField("state")
                                        }
                                      },
                                      model: {
                                        value: _vm.requestToJoinForm.state,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.requestToJoinForm,
                                            "state",
                                            $$v
                                          )
                                        },
                                        expression: "requestToJoinForm.state"
                                      }
                                    },
                                    _vm._l(_vm.STATES(), function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Email", prop: "email" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "100",
                                      placeholder: "Your email"
                                    },
                                    model: {
                                      value: _vm.requestToJoinForm.email,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestToJoinForm,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression: "requestToJoinForm.email"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Phone Number",
                                    prop: "phoneNumber"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "20",
                                      placeholder: "Your phone number"
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.requestToJoinForm.phoneNumber = _vm.formatPhoneNumber(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.requestToJoinForm.phoneNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestToJoinForm,
                                          "phoneNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "requestToJoinForm.phoneNumber"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "Message", prop: "message" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      maxlength: "1000",
                                      "show-word-limit": "",
                                      placeholder: "Message"
                                    },
                                    model: {
                                      value: _vm.requestToJoinForm.message,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.requestToJoinForm,
                                          "message",
                                          $$v
                                        )
                                      },
                                      expression: "requestToJoinForm.message"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "submit-button",
                                      on: {
                                        click: function($event) {
                                          return _vm.onSubmit(
                                            "requestToJoinForm"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v("Confirm\n                  "),
                                      _vm.loading
                                        ? _c("i", {
                                            staticClass: "el-icon-loading"
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78876608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78876608","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/requestToJoinUConnectCorporateDialog.vue
// module id = null
// module chunks = 